const MASTER_LABEL_IMAGE_SLIDER_MIN = 16;
const MASTER_LABEL_IMAGE_SLIDER_MAX = 260;
const MASTER_LABEL_REFERENCE_IMAGE_MAX = 109;
const MASTER_LABEL_REFERENCE_CURVE_STRENGTH = 7;

function clampMasterLabelSliderValue(value: number): number {
  return Math.min(MASTER_LABEL_IMAGE_SLIDER_MAX, Math.max(MASTER_LABEL_IMAGE_SLIDER_MIN, value));
}

export function resolveMasterLabelImageSizes(sliderValue: number): {
  cropSizePx: number;
  referenceSizePx: number;
} {
  const cropSizePx = clampMasterLabelSliderValue(sliderValue);
  const progress =
    (cropSizePx - MASTER_LABEL_IMAGE_SLIDER_MIN) /
    (MASTER_LABEL_IMAGE_SLIDER_MAX - MASTER_LABEL_IMAGE_SLIDER_MIN);
  const normalizedReferenceProgress =
    Math.log1p(MASTER_LABEL_REFERENCE_CURVE_STRENGTH * progress) /
    Math.log1p(MASTER_LABEL_REFERENCE_CURVE_STRENGTH);
  let referenceSizePx = Math.round(
    MASTER_LABEL_IMAGE_SLIDER_MIN +
      (MASTER_LABEL_REFERENCE_IMAGE_MAX - MASTER_LABEL_IMAGE_SLIDER_MIN) *
        normalizedReferenceProgress
  );
  if (
    cropSizePx < MASTER_LABEL_IMAGE_SLIDER_MAX &&
    referenceSizePx >= MASTER_LABEL_REFERENCE_IMAGE_MAX
  ) {
    referenceSizePx = MASTER_LABEL_REFERENCE_IMAGE_MAX - 1;
  }

  return {
    cropSizePx,
    referenceSizePx,
  };
}
